import { sm2 } from "sm-crypto"; // 获取sm2对象
const cipherMode = 0; // 选择加密策略，1 - C1C3C2，0 - C1C2C3，默认为1
const sysPublicKey =
  "03d9bc7ed5cbb2b8b4524f6efef36257f56daeae8904e2fc9eb97cffd6d10da7a5"; // 系统后台公钥

/**
 * SM2加密string数据
 * @param {string} data 原始数据
 * @returns {string} 加密后数据
 */
export function encryptString(data) {
  if (data && typeof data === "string" && data.constructor === String) {
    return "04" + sm2.doEncrypt(data, sysPublicKey, cipherMode);
  }
  return null;
}

/**
 * SM2加密object数据
 * @param {Object} data 原始数据
 * @returns {string} 加密后数据
 */
export function encryptObj(data) {
  if (data) {
    return "04" + sm2.doEncrypt(JSON.stringify(data), sysPublicKey, cipherMode);
  }
  return null;
}
